export { default } from './AlterLogPunch.js';